import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { BankAccount } from '../../types'
import { customersBankAccountType } from '../../lib'
import BankIcon from '../../assets/icons/bank-icon.svg'
import { baseButtonTextWhiteBg } from '../../theme/custom-styles'

export const RegisteredBankAccountItem = ({
  bankAccountData,
  handleSelectRegisteredBankAccount
}: {
  bankAccountData: BankAccount
  handleSelectRegisteredBankAccount: (selectedRegsiteredBankAccount: BankAccount) => void
}) => {
  const { t } = useTranslation(['payments-to-review-management', 'common'])
  console.log('bankAccountData?.bankAccountType', bankAccountData?.bankAccountType)

  return (
    <div
      style={{ cursor: 'pointer' }}
      className="registered-bank-account-item-container"
      onClick={() => handleSelectRegisteredBankAccount(bankAccountData)}
    >
      <div className="left-content">
        <div className="icon-container">
          <img
            src={BankIcon}
            alt="bank-icon"
          />
        </div>
        <div className="bank-account-data-text">{`${(customersBankAccountType as any)[bankAccountData?.bankAccountType ?? '3']} ${bankAccountData?.bankName} - No. ${bankAccountData?.bankNumber}`}</div>
      </div>
      <div className="right-content">
        <Button
          fullWidth
          variant="text"
          sx={baseButtonTextWhiteBg}
          className="actions-bar-button-action"
          onClick={() => handleSelectRegisteredBankAccount(bankAccountData)}
        >
          <div className="actions-bar-button-action-text">{t('customerBanksAccountsModal.selectButton')}</div>
        </Button>
      </div>
    </div>
  )
}
